import Accordion from "./modules/Accordion"; 
import HamburgerMenu from "./modules/HamburgerMenu";
import News from "./modules/News";
import Mv from "./modules/Mv";
import Header from "./modules/Header";
import ScrollBtn from "./modules/ScrollBtn";
import ThumbnailSLider from "./modules/ThumbnailSLider";
import Catalouge from "./modules/Catalouge"
import Filter from "./modules/Filter";
import Anchor from "./modules/Anchor";

// import AOS animation js
import AOS from 'aos';
// import AOS animation styles
import 'aos/dist/aos.css';
// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';


document.addEventListener("DOMContentLoaded", () => {
    const hamburgerMenu = new HamburgerMenu(); 
    const serviceAccordion = new Accordion({
        parent: 'cmp-service__accordion-tab', 
        opener: 'cmp-service__accordion-tab-label', 
        panel: 'cmp-service__accordion-tab-content',
        isResetable: false
    });
    const hamburgerMenuAccordion = new Accordion({
        parent:'fts-header__nav-group', 
        opener:'fts-header__nav-label', 
        panel: 'fts-header__nav-menu', 
        spOnly: true
    });
    const news = new News('.cmp-news__categories-nav-tab', '.cmp-news__panel');
    const mv = new Mv();
    const header = new Header();
    const scrollBtn = new ScrollBtn();
    const catalougeModal = new Catalouge({
        modalId: 'catalougeDownloader',
        modalOpener: 'catalouge-modal-opener',
        modalCloser: 'modalCLoser'
    }, 'catalouge__download-btn');
    const filter = new Filter({
        modalId: 'productFilter',
        modalCloser: 'modalCLoser',
        modalOpener: 'side-cta-button--search'
    });
    const thumbnailSLider = new ThumbnailSLider();
    const anchor = new Anchor();
    
    const overviewHistorySlider = new Swiper('.overview-history__swiper', {
        slidesPerView: 1,
        speed: 2000,
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                loopPreventsSliding: false
            }
        },
        autoplay: {
            delay: 300,
            pauseOnMouseEnter: true
        },
        navigation: {
            nextEl: '.overview-history__swiper-btn--next',
            prevEl: '.overview-history__swiper-btn--prev',
        },
        loop: true
    });
    const slideWidthDot = new Swiper('.slider-w-dot-nav', {
        slidesPerView: 1,
        speed: 2000,
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
            el: '.slider-w-dot-nav__pagination',
            type: 'bullets',
            clickable: true,
        },
        autoplay: {
            delay: 300,
            pauseOnMouseEnter: true
        },
        loop: true
    });

    const productsSLider = new Swiper('.cmp-products__slider', {
        slidesPerView: 1.2,
        speed: 2000,
        spaceBetween: 5,
        grabCursor: true,
        autoplay: {
            delay: 300,
            pauseOnMouseEnter: true
        },
        loop: true,
        breakpoints: {
            600: {
                slidesPerView: 2.5,
                loopPreventsSliding: false
            },
            768: {
                slidesPerView: 3.5,
                loopPreventsSliding: false
            }

        },
        navigation: {
            nextEl: '.cmp-products__slider-btn--next',
            prevEl: '.cmp-products__slider-btn--prev',
        },
        scrollbar: {
            el: '.cmp-products__slider-scrollbar',
            dragClass: 'slider-nav__scrollbar-drag cmp-products__slider-scrollbar-drag',
            draggable: true        
        }
    });

    const newsSLider = new Swiper('.cmp-news__swiper', {
        slidesPerView: 1,
        speed: 5000,
        spaceBetween: 20,
        grabCursor: true,
        navigation: {
            nextEl: '.cmp-news__swiper-btn--next',
            prevEl: '.cmp-news__swiper-btn--prev',
        },
        scrollbar: {
            el: '.cmp-news__swiper-scrollbar',
            dragClass: 'slider-nav__scrollbar-drag cmp-news__swiper-scrollbar-drag',
            draggable: true        
        }
    });

    const cmpSlider = new Swiper('.cmp-slider', {
        slidesPerView: 2,
        autoplay: {
            delay: 300,
            pauseOnMouseEnter: true
        },
        loop: true,
        speed: 5000,
        spaceBetween: 20,
        centeredSlides: true,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 40,
                loopPreventsSliding: false
            }

        }
    });
    // initialize AOS Animation
    AOS.init({
        duration:2000,
        once: true
    }); 

});
